// Customer photo gallery — real cruise moments.
export const GALLERY = [
    {
        type: 'video',
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/bs9os2px_VID_20260520_171213.mp4',
        caption: 'Sail-Away Moment · Captured Live',
        location: 'Onboard · Departure Day',
        tag: 'Video · Sail Day',
        date: 'May 20, 2026',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/lbb41eqr_Screenshot_20260515_161248_Facebook.jpg',
        caption: 'Perfect Day at CocoCay · Squad Goals',
        location: 'CocoCay, Bahamas · Wonder of the Seas',
        tag: 'Group · Royal Caribbean',
        date: 'May 10, 2026',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/mzlk0tmn_Screenshot_20260515_165126_Messages.jpg',
        caption: 'Friends & Family Trip · Bahamas 2026',
        location: 'Miami → CocoCay → Nassau · Wonder of the Seas',
        tag: 'Group · Family Reunion',
        date: 'May 11, 2026',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/nddio0ze_Screenshot_20260506_061018_Facebook.jpg',
        caption: 'Yellow on the Crystal Water',
        location: 'CocoCay Beach · Bahamas',
        tag: 'Beach · Solo',
        date: 'May 5, 2026',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/mlxwfkb4_Screenshot_20260601_142946_Facebook.jpg',
        caption: 'Half Moon Cay · Beach Day with the Boo',
        location: 'Half Moon Cay, Bahamas',
        tag: 'Couples · Excursion',
        date: 'Aug 23, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/wsmnlvz1_Screenshot_20260601_144240_Facebook%281%29.jpg',
        caption: 'Girls Trip · Pool Deck Photo Op',
        location: 'Carnival Freedom · Deck 9',
        tag: 'Group · Girls Trip',
        date: 'Aug 22, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/gdq2lhaq_Screenshot_20260601_144435_Facebook.jpg',
        caption: 'Daddy-Daughter Dance Floor Moment',
        location: 'Resort Ballroom · Family Celebration',
        tag: 'Family',
        date: 'Jun 1, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/joms7t77_Screenshot_20260601_142959_Facebook.jpg',
        caption: 'Caribbean Sunshine · Beach Club Lounge',
        location: 'Private Island Beach Club',
        tag: 'Couples · Beach',
        date: 'Aug 24, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/i8fhyyt9_Screenshot_20260601_143139_Facebook.jpg',
        caption: 'All-White Night · The Whole Crew',
        location: 'Onboard · Main Lounge',
        tag: 'Group · Theme Night',
        date: 'Aug 23, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/g91z11fv_Screenshot_20260601_143610_Facebook.jpg',
        caption: 'Carnival Freedom · Bahamas Vow Renewal',
        location: 'Port Canaveral, FL → Bahamas',
        tag: 'Group Cruise',
        date: 'Aug 21, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/3i46oxo5_Screenshot_20260601_144521_Facebook.jpg',
        caption: 'Friday Cocktails at the Lounge',
        location: 'Onboard · Adults Only Bar',
        tag: 'Nightlife',
        date: 'Aug 22, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/r671z0w9_Screenshot_20260601_144602_Facebook.jpg',
        caption: 'Date Night · Captain\'s Lounge',
        location: 'Carnival Freedom · Lounge Deck',
        tag: 'Couples',
        date: 'Aug 23, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/xnwuo9ub_Screenshot_20260601_142919_Facebook.jpg',
        caption: 'McDowell FunTastic Vow Renewal Crew',
        location: 'Suite · Pre-Embarkation',
        tag: 'Group · Birthday',
        date: 'Aug 21, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/5jmk1kus_Screenshot_20260601_144626_Facebook.jpg',
        caption: 'Pre-Cruise Hype — Orlando Airport',
        location: 'Orlando International Airport',
        tag: 'Travel Day',
        date: 'Aug 20, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/55s5x82f_Screenshot_20260601_142907_Facebook.jpg',
        caption: 'Matching Tees · Bus to the Port',
        location: 'McDowell FunTastic Vow Renewal · Port Transfer',
        tag: 'Group · Vow Renewal',
        date: 'Aug 21, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/1bcxaqqe_Screenshot_20260601_143636_Facebook.jpg',
        caption: 'Half Moon Cay — Group Shot Under the Palms',
        location: 'Half Moon Cay, Bahamas · Carnival Freedom',
        tag: 'Excursion',
        date: 'Aug 23, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/zgvmeszr_Screenshot_20260601_144258_Facebook.jpg',
        caption: 'Cake Cutting · Sweet 16 Celebration',
        location: 'Resort Ballroom · Family Celebration',
        tag: 'Birthday',
        date: 'Jun 1, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/yfuw2uew_Screenshot_20260601_143037_Facebook.jpg',
        caption: 'Buffet Night — All Smiles',
        location: 'Onboard · Main Dining Room',
        tag: 'Cuisine',
        date: 'Aug 22, 2025',
    },
    {
        src: 'https://customer-assets.emergentagent.com/job_voyage-party/artifacts/irr1rse8_Screenshot_20260601_142810_Facebook.jpg',
        caption: 'Bonaire — It\'s In Our Nature',
        location: 'Bonaire · Caribbean Excursion',
        tag: 'Destinations',
        date: 'Aug 24, 2025',
    },
];
